import _ from 'lodash';
import { Validators } from '@angular/forms';
import * as moment from 'moment';
import { EventConfigSchema, SlideSchema, SponsorSchema } from './virtual-event';

export const InPersonEventSchema = {
  'arrays': [
    {
      'array': 'sponsors',
      'schema': SponsorSchema,
      'value': [],
      'validators': []
    }, {
      'array': 'pageConfig',
      'schema': EventConfigSchema,
      'value': [],
      'validators': []
    }],
    'groups': [{
      'group': 'eventVenue',
      'fields': [{
        'field': 'formatted_address',
        'value': '',
        'validators': []
      }, {
        'field': 'name',
        'value': '',
        'validators': []
      }, {
        'field': 'address',
        'value': {},
        'validators': [],
        'options': {
            'getter': (control, form) => {
                const { value: unitNum } = form.get('unitNum');
                if(control.value instanceof Object) {
                    return { ...control.value, unitNum: unitNum };
                }
                return control.value;
            }
        }
      }, {
          'field': 'unitNum',
          'value': '',
          'validators': [],
          'options': {
              'virtual': true,
              'setter': (data, value) => {
                  if(data && data.address && data.address instanceof Object) {
                      return data.address.unitNum;
                  }
                  return value;
              }
          }
      }]
    },{
    'group': 'timeZoneData',
    'fields': [{
      'field': 'name',
      'value': () => moment.tz.guess(),
      'validators': [],
      'options': {
        'setter': (data, value) => _.isFunction(value) ? value() : value
      }
    }, {
      'field': 'abbr',
      'value': () => {
        const guess = moment.tz.guess();
        const zone = moment.tz.zone(guess);
        const timestamp = (new Date()).getTime();
        return zone.abbr(timestamp);
      },
      'validators': [],
      'options': {
        'setter': (data, value) => _.isFunction(value) ? value() : value
      }
    }, {
      'field': 'offset',
      'value': () => {
        const guess = moment.tz.guess();
        const zone = moment.tz.zone(guess);
        const timestamp = (new Date()).getTime();
        const abbr = zone.abbr(timestamp);
        const index = _.findIndex(zone.abbrs, (value) => _.isEqual(value, abbr));
        return zone.offsets[index] * -60;
      },
      'validators': [],
      'options': {
        'setter': (data, value) => _.isFunction(value) ? value() : value
      }
    }]
  }],
    'fields': [{
        'field': 'id',
        'value': null,
        'validators': []
    }, {
        'field': 'name',
        'value': '',
        'validators': [Validators.required, Validators.maxLength(128)]
    }, {
        'field': 'desc',
        'value': '',
        'validators': []
    },
      {
        'field': 'imageFile',
        'value': null,
        'validators': [],
        'options': {
            'virtual': true
        }
    }, {
        'field': 'image',
        'value': '/images/blank_2x1.png',
        'validators': [],
        'options': {
            'getter': (control) => {
                return control.value === '/images/blank_2x1.png' ? '': control.value;
            },
            'setter': (data, value) => {
                return value === '' ? '/images/blank_2x1.png': value;
            }
        }
    }, {
        'field': 'startDateTimeGmtUnix',
        'value': null,
        'validators': [Validators.required, Validators.nullValidator, Validators.min(1)],
      }, {
        'field': 'duration',
        'value': 60,
        'validators': [Validators.required, Validators.min(1), Validators.max(1440)],
        'options': {
            'setter': (data, value) => {
                if(_.isNumber(value)) {
                    return value < 1 ? 60: value;
                }
                return 60;
            }
        }
      },{
        'field': 'hideCoverFee',
        'value': false,
        'validators': []
    },  {
      'field': 'coverFeeDefaultOff',
      'value': false,
      'validators': [],
      'options': {
        'setter': (data, value) => {
            return value;
        }
    }
      
    }, {
        'field': 'imageDataUrl',
        'value': '/images/blank_2x1.png',
        'validators': [],
        'options': {
            'virtual': true,
            'getter': (control) => {
                return control.value === '/images/blank_2x1.png' ? '': control.value;
            },
            'setter': (data, value) => {
                return data.image === '' ? '/images/blank_2x1.png': data.image;
            }
        }
    }, {
        'field': 'paddleRequired',
        'value': false,
        'validators': []
    }, {
        'field': 'paddleMinNum',
        'value': 101,
        'validators': [],
        'options': {
            'validators': (data, value) => {
                return data.paddleRequired ?
                    [Validators.required, Validators.min(1)]:
                    [Validators.required, Validators.min(0)];
            }
        }
    }, {
        'field': 'emptyPaddleCount',
        'value': 10,
        'validators': [],
        'options': {
            'validators': (data, value) => {
                return [Validators.required];
            }
        }
    }, {
        'field': 'timeZoneList',
        'value': () => {
          const timestamp = new Date().getTime() / 1000;
          const zones = moment.tz.names();
          return _.map(zones, (name, index) => {
            const label = `(GMT ${moment.tz(timestamp, name).format('Z')}) ${name} - ${moment.tz(timestamp, name).format('z')}`;
            return {index, label, value: name};
          });
        },
        'validators': [],
        'options': {
          'virtual': true,
          'setter': (data, value) => _.isFunction(value) ? value() : value
        }
      }, {
        'field': 'timeZone',
        'value': () => (new Date()).getTimezoneOffset() * -60,
        'validators': [Validators.required],
        'options': {
          'setter': (data, value) => _.isFunction(value) ? value() : value
        }
      }, {
        'field': 'timeZoneAbbr',
        'value': () => (new Date()).toLocaleTimeString('en-us', {timeZoneName: 'short'}).split(' ')[2],
        'validators': [],
        'options': {
          'setter': (data, value) => _.isFunction(value) ? value() : value
        }
      }, {
        'field': 'tableRequired',
        'value': false,
        'validators': []
    }, {
        'field': 'golfPackEnabled',
        'value': false,
        'validators': []
    }, {
        'field': 'ticketCampaigns',
        'value': [],
        'validators': []
    }, {
        'field': 'ticketCampaignsInfo',
        'value': [],
        'validators': []
    }]
};
